export default __webpack_public_path__ + "static/media/irda-logo.9e6db3a0.png";